export enum ArtefactKind {
  Delivery = "delivery",
  Documentation = "documentation",
  Counting = "counting",
  Differentiation = "differentiation",
  Inspection = "inspection",
}

export const ArtefactKindList: ArtefactKind[] = Object.values(ArtefactKind);

/**
 * artefactKindsUpTo returns the given kind and every kind preceding it in the
 * milestone pipeline. The declaration order of ArtefactKind is the pipeline
 * order: delivery -> documentation -> counting -> differentiation -> inspection.
 */
export function artefactKindsUpTo(kind: ArtefactKind): ArtefactKind[] {
  const idx = ArtefactKindList.indexOf(kind);
  return idx < 0 ? [] : ArtefactKindList.slice(0, idx + 1);
}
